import React from "react";
import {
  Button,
  CardBody,
  Copy,
  CenterCenter
} from "app/NativeComponents/common";

import { store } from "app/store";

const RemoveTextButton = ({ style, text, onPress }) => {
  const colors = store.getState().settings.colors;

  return (
    <Button onPress={onPress}>
      <CardBody style={style}>
        <CenterCenter>
          <Copy style={{ color: colors.error_color }}>{text}</Copy>
        </CenterCenter>
      </CardBody>
    </Button>
  );
};

export { RemoveTextButton };
